export const isChanged = (differences, value) =>
  differences?.find(
    (d) =>
      d.modifiedField?.toLowerCase() === value.toLowerCase() ||
      d.fieldName?.toLowerCase() === value.toLowerCase()
  );
